import { REST_RADIUS } from './particleField';

/** Gap between Anna's sphere and the caption beneath her — shared by the wall and the boot overlay */
export const CAPTION_GAP = 22;

/** Wordmark size where Anna is large (wall) and where she is small (desk, phone) */
export const wordmarkSize = (R: number) => (R >= 200 ? 64 : 40);

export interface AnchorGeometry {
  cx: number;
  cy: number;
  /** Visible radius of Anna's sphere at rest */
  R: number;
}

/**
 * Where the real Anna lives on the current screen. Avatars rendered with `anchor` carry
 * data-anna-anchor; the boot sequence forms its orb exactly there so the hand-over is seamless.
 */
export function findAnnaAnchor(): AnchorGeometry | null {
  const nodes = Array.from(document.querySelectorAll<HTMLElement>('[data-anna-anchor]'));
  for (const el of nodes) {
    const r = el.getBoundingClientRect();
    if (r.width < 8 || r.bottom < 0 || r.top > window.innerHeight) continue;
    return { cx: r.left + r.width / 2, cy: r.top + r.height / 2, R: (Math.min(r.width, r.height) / 2) * REST_RADIUS };
  }
  return null;
}

/** No avatar on this screen (Beheer, Spec): Anna forms centre stage instead. */
export function fallbackAnchor(w: number, h: number): AnchorGeometry {
  return { cx: w / 2, cy: h * 0.44, R: Math.min(w, h) * 0.17 };
}
